import React, { useEffect, useRef, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import LandingPage from './LandingPage';
import GamePage from './GamePage';
import AdminPage from './AdminPage';
import ResultPage from './ResultPage';

function InactivityHandler({ children }) {
    const navigate = useNavigate();
    const location = useLocation();
    const timerRef = useRef(null);

    const resetTimer = () => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        if (location.pathname !== '/') {
            timerRef.current = setTimeout(() => {
                navigate('/');
            }, 30000);
        }
    };

    useEffect(() => {
        resetTimer();
        const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];
        const handleActivity = () => resetTimer();
        events.forEach(event => window.addEventListener(event, handleActivity));
        return () => {
            if (timerRef.current) clearTimeout(timerRef.current);
            events.forEach(event => window.removeEventListener(event, handleActivity));
        };
    }, [location.pathname, navigate]);

    return children;
}

function BackgroundManager({ children }) {
    const location = useLocation();
    const [bgImage, setBgImage] = useState(null);

    useEffect(() => {
        if (location.pathname === '/admin') {
            document.body.style.backgroundImage = '';
            document.body.style.background = '';
            return;
        }

        let pageName = 'landing';
        if (location.pathname === '/game') pageName = 'game';
        else if (location.pathname === '/result') pageName = 'result';

        const imgUrl = `/api/images/bg_${pageName}.png`;

        fetch(imgUrl)
            .then(res => {
                if (res.ok) {
                    setBgImage(`url('${imgUrl}?t=${new Date().getTime()}')`);
                } else {
                    setBgImage(null);
                }
            })
            .catch(() => setBgImage(null));
    }, [location.pathname]);

    useEffect(() => {
        if (location.pathname === '/admin') return;

        if (bgImage) {
            document.body.style.backgroundImage = bgImage;
            document.body.style.backgroundSize = 'cover';
            document.body.style.backgroundPosition = 'center';
            document.body.style.backgroundRepeat = 'no-repeat';
        } else {
            document.body.style.backgroundImage = '';
            document.body.style.background = '';
        }
    }, [bgImage, location.pathname]);

    return children;
}

function TitleManager({ children }) {
    useEffect(() => {
        fetch('/api/config')
            .then(res => res.json())
            .then(data => {
                document.title = data.pageTitle || '아트몰링 초성게임';
            })
            .catch(() => {
                document.title = '아트몰링 초성게임';
            });
    }, []);

    return children;
}

function App() {
  return (
    <Router>
      <InactivityHandler>
        <TitleManager>
          <BackgroundManager>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/game" element={<GamePage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/result" element={<ResultPage />} />
            </Routes>
          </BackgroundManager>
        </TitleManager>
      </InactivityHandler>
    </Router>
  );
}

export default App;
